/**
 * ScrollAnchor Utility - Legacy wrapper for backward compatibility
 *
 * @deprecated Use ScrollAnchorProvider and useScrollAnchor from contexts/ScrollAnchorContext.tsx instead
 */

export {
  useScrollAnchor,
  ScrollAnchorProvider,
} from "@contexts/ScrollAnchorContext";
export type { ScrollAnchorOptions } from "@contexts/ScrollAnchorContext";
